import { features } from '@/mocks/homeData';

export default function FeatureGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <div className="mb-10 md:mb-14">
          <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">
            Warum wir?
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Ihre Vorteile mit dem
            <br />
            OOPBUY Spreadsheet
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/60 hover:border-background-300 transition-colors group"
            >
              <span className="inline-flex w-11 h-11 items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </span>
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}